import {
  getFirestore,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  collection,
  deleteField,
  where,
  query,
} from "firebase/firestore";
import * as Sentry from "@sentry/react";

const db = getFirestore();

/**
 * Fetch user details from Firestore
 * @param {Array} userIds - List of user IDs to fetch
 * @returns {Object} - Object mapping user IDs to user data
 */
export const fetchUserDetails = async (userIds) => {
  const userData = {};

  for (const userId of userIds) {
    if (!userId) continue; // Skip invalid IDs
    const userRef = doc(db, "users", userId);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      userData[userId] = userSnap.data();
    }
  }

  return userData;
};

export const updateUserRole = async (userId, { role, adminFor }) => {
  const userRef = doc(db, "users", userId);
  await updateDoc(userRef, { role, adminFor });
};

export const fetchUsers = async () => {
  const usersCollection = collection(db, "users");
  const usersSnapshot = await getDocs(usersCollection);
  console.log(`Firestore read count: ${usersSnapshot.docs.length}`);
  return usersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const revokeAdmin = async (userId) => {
  const userRef = doc(db, "users", userId);
  await updateDoc(userRef, {
    role: "user",
    adminFor: deleteField(), // removes the field entirely
  });
};

export const fetchUsersByIds = async (userIds = []) => {
  try {
    if (userIds.length === 0) return [];

    // Firestore's `in` query supports up to 10 items per query
    const chunkSize = 10;
    const userChunks = [];

    for (let i = 0; i < userIds.length; i += chunkSize) {
      userChunks.push(userIds.slice(i, i + chunkSize));
    }
    console.log(
      `📥 Firestore will perform ${userChunks.length} read(s) to fetch ${userIds.length} user(s)`
    );

    const results = [];
    for (const chunk of userChunks) {
      const q = query(collection(db, "users"), where("__name__", "in", chunk));
      const snapshot = await getDocs(q);
      snapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });
    }

    return results;
  } catch (error) {
    Sentry.captureException(error);
    console.error("Erreur lors de la récupération des utilisateurs :", error);
    return [];
  }
};
